module.exports = __webpack_public_path__ + "static/media/media_right_arrow.88b10600.svg";